import { all } from 'redux-saga/effects';
import welcomeSagas from './welcome/saga';

export default function* rootSaga(getState) {
  yield all([
    welcomeSagas()
  ]);
}
